import { sectionNames } from "@saleor/intl";
import { asSortParams } from "@saleor/utils/sort";
import { parse as parseQs } from "qs";
import React from "react";
import { useIntl } from "react-intl";
import { Route, Routes, useLocation, useParams } from "react-router-dom";

import { WindowTitle } from "../components/WindowTitle";
import PermissionGroupMultiFactorAuthentication from "./components/PermissionGroupMultiFactorAuthentication";
import {
  MembersListUrlSortField,
  PermissionGroupDetailsUrlQueryParams,
  PermissionGroupListUrlQueryParams,
  PermissionGroupListUrlSortField
} from "./urls";
import PermissionGroupCreate from "./views/PermissionGroupCreate";
import PermissionGroupDetailsComponent from "./views/PermissionGroupDetails";
import PermissionGroupListComponent from "./views/PermissionGroupList";

const PermissionGroupList: React.FC = () => {
  const location = useLocation();
  const qs = parseQs(location.search.substr(1));
  const params = asSortParams(
    qs,
    PermissionGroupListUrlSortField
  ) as PermissionGroupListUrlQueryParams;

  return <PermissionGroupListComponent params={params} />;
};

const PermissionGroupDetails: React.FC = () => {
  const { id } = useParams();
  const qs = parseQs(location.search.substr(1));
  const params = asSortParams(
    qs,
    MembersListUrlSortField
  ) as PermissionGroupDetailsUrlQueryParams;

  return (
    <PermissionGroupDetailsComponent
      id={decodeURIComponent(id)}
      params={params}
    />
  );
};

const Component = () => {
  const intl = useIntl();

  return (
    <>
      <WindowTitle title={intl.formatMessage(sectionNames.permissionGroups)} />
      <Routes>
        <Route path={""} element={<PermissionGroupList />} />
        <Route path={"add"} element={<PermissionGroupCreate />} />
        <Route path={":id"} element={<PermissionGroupDetails />} />
        <Route
          path={"multi-factor-authentication"}
          element={<PermissionGroupMultiFactorAuthentication />}
        />
      </Routes>
    </>
  );
};

export default Component;
